export const ROUTES = {
  HOME: {
    label: 'Home',
    path: '/',
    mainNav: false,
  },
  BATCH_RATE: {
    label: 'Batch Rate Request',
    path: '/batch-rate',
    mainNav: true,
  },
  AP_TESTING: {
    label: 'AP Testing Request',
    path: '/ap-testing',
    mainNav: true,
  },
  RATE_COMPARE: {
    label: 'Rate Compare Request',
    path: '/rate-compare',
    mainNav: true,
  },
  PARCEL_RATE: {
    label: 'Parcel Rate Request',
    path: '/parcel-rate',
    mainNav: true,
  },
  GEO_MILEAGE: {
    label: 'GEO Mileage Request',
    path: '/geo-mileage',
    mainNav: true,
  },
  INVOICE_AUDIT: {
    label: 'Invoice Audit Analysis Request',
    path: '/invoice-audit',
    mainNav: true,
  },
  UPLOAD_ANALYZE: {
    label: 'Custom Analysis Request',
    path: '/upload-analyze',
    mainNav: true,
  },
  PULL_DATA: {
    label: 'Shipment Retrieval Request',
    path: '/pull-data',
    mainNav: true,
  },
  PULL_AND_SEND: {
    label: 'Pull & Send Request',
    path: '/pull-and-send',
    mainNav: false,
  },
  RESULTS: {
    label: 'View Results',
    path: '/results',
    mainNav: true,
  },
  RUNTIME_HUB: {
    label: 'Runtime Hub',
    path: '/runtime-hub',
    mainNav: true,
  },
  SIGNIN_CALLBACK: {
    path: '/signin-callback',
    mainNav: false,
  },
} as const;
